import { Context, createContext, useContext } from 'react';
import { ClientApi } from '../api/clientApi';

let ClientApiContext: Context<{
  clientApi: ClientApi;
}>;

export const createClientApi = (clientApiInstance: ClientApi) => {
  return (ClientApiContext = createContext({ clientApi: clientApiInstance }));
};

export const useClientApi = () => {
  try {
    return useContext(ClientApiContext);
  } catch {
    throw new Error(
      "ClientApiContext: useContext was called before it's creation",
    );
  }
};
